import React from "react";
import PropTypes from "prop-types";

import FilterStatusCheckbox from "./FilterStatusCheckbox";

export default function FilterStatusCheckboxList({
  statuses,
  multipleActiveAllowed,
}) {
  return (
    <div>
      {statuses.map((status, i) => (
        <FilterStatusCheckbox
          key={i}
          status={status}
          multipleActiveAllowed={multipleActiveAllowed}
        />
      ))}
    </div>
  );
}

FilterStatusCheckboxList.propTypes = {
  statuses: PropTypes.arrayOf(PropTypes.object).isRequired,
  multipleActiveAllowed: PropTypes.bool,
};
